(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-block"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper('.swiper-cards', {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination.about-block",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-packaging"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".packaging-swiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: ".swiper-pagination.about-package",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-pillar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper !== "undefined") {
      new Swiper(".pillars-swiper", {
        loop: true,
        pagination: {
          el: ".swiper-pagination.about-pillar",
          clickable: true,
        },
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof window.jQuery === "undefined") return;
  if (!document.querySelector(".announcement-bar")) return;

  var SLICK_SRC = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";

  function initAnnouncementBar() {
    jQuery(function ($) {
      if (!$.fn.slick) return;

      $(".announcement-bar").not(".slick-initialized").slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,          // no delay between scrolls
      speed: 5000,               // adjust for scroll speed (higher = slower)
      cssEase: 'linear',
      arrows: false,
      dots: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1366,
          settings: {
            slidesToShow: 3,
            variableWidth: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            variableWidth: true
          }
        }
      ]
      });
    });
  }

  // Already available (another section loaded it) -- go straight to init.
  if (window.jQuery.fn && window.jQuery.fn.slick) {
    initAnnouncementBar();
    return;
  }

  // Another section is already fetching it -- wait for that request.
  var pending = document.querySelector("script[data-slick-loader]");
  if (pending) {
    pending.addEventListener("load", initAnnouncementBar);
    return;
  }

  var script = document.createElement("script");
  script.src = SLICK_SRC;
  script.setAttribute("data-slick-loader", "1");
  script.onload = initAnnouncementBar;
  script.onerror = function () {
    console.error("[announcement-slider] slick-carousel failed to load");
  };
  document.head.appendChild(script);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) { card.scrollIntoView({ behavior: 'instant' }); }
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();
})();
